<template>
          <v-container fluid>
          <v-data-table
              :headers="headers"
              :items="files"
              :pagination.sync="pagination"
              :total-items="totalFiles"
              :loading="loading"
              class="elevation-1 mt-3"
            >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.fileName }}</td>
              <td>{{ props.item.createdBy }}</td>
              <td>{{ props.item.createdAt }}</td>
              <td>{{ props.item.approved }}</td>
              <td> <v-btn color="#1f5b41" class="white--text" @click="approveFile(props.item)">Approve</v-btn></td>
              <td> <v-btn @click="rejectFile(props.item)">Reject</v-btn></td>
              <td> <v-btn @click="viewFile(props.item)">View</v-btn></td>
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
            </template>
           </v-data-table>
           <v-dialog v-model="viewRecordsDialog" max-width="900px">
             <v-card>
               <v-card-text>
                 <v-data-table :headers="viewFileheaders" :items="records" class="elevation-1 mt-3">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.merchantId }}</td>
                    <td>{{ props.item.terminalId }}</td>
                    <td>{{ props.item.firstEmail }}</td>
                    <td>{{ props.item.secondEmail }}</td>
                    <td>{{ props.item.orgName }}</td>
                    <td>{{ props.item.firstCustomerFirstName }}</td>
                    <td>{{ props.item.firstCustomerLastName }}</td>
                    <td>{{ props.item.secondCustomerFirstName }}</td>
                    <td>{{ props.item.secondCustomerLastName }}</td>
                  </template>
                  <template slot="no-data">
                    <p> No data Found </p>
                    <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
                  </template>
                </v-data-table>
               </v-card-text>
               <v-card-actions>
                 <v-spacer></v-spacer>
                 <v-btn color="white" @click="viewRecordsDialog=false">Cancel </v-btn>
               </v-card-actions>
             </v-card>
           </v-dialog>
        </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'uploadfile',
  data: function() {
    return {
      file: '',
      message: '',
      error: '',
      files: [],
      loading: true,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'File Name', value: 'fileName' },
        { text: 'Created By', value: 'createdBy' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Approved', value: 'approved' }
      ],
      viewFileheaders: [
        { text: 'Merchant Id', value: 'merchantId' },
        { text: 'Terminal Id', value: 'terminalId' },
        { text: 'First Email', value: 'firstEmail' },
        { text: 'Second Email', value: 'secondEmail' },
        { text: 'Org Name', value: 'orgName' },
        { text: 'First Customer First Name', value: 'firstCustomerFirstName' },
        { text: 'First Customer Last Name', value: 'firstCustomerLastName' },
        { text: 'Second Customer First Name', value: 'secondCustomerFirstName' },
        { text: 'Second Customer Last Name', value: 'secondCustomerLastName' }
      ],
      pagination: {sortBy: 'id', descending: true},
      totalFiles: 0,
      records: [],
      viewRecordsDialog: false
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  methods: {
    approveFile (item) {
      this.message = ''
      this.error = ''
      var url = config.serverURI + '/bulk_upload/approve'
      var token = store.state.token
      axios.post(url, item, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          if (response.status !== 200) {
            this.error = response.statusText
            console.log('Error is ' + this.error)
            return
          }
          if (response.data.error !== false) {
            this.error = response.data.message
            console.log('Error is ' + this.error)
            return
          }
          this.message = response.data.message
          this.getDataFromApi()
        })
        .catch(error => {
          console.log('error', error.response)
          var data = error.response.data
          console.log(data.message)
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.message
          }
        })
    },
    rejectFile (item) {
      this.message = ''
      this.error = ''
      var url = config.serverURI + '/bulk_upload/reject'
      var token = store.state.token
      axios.post(url, item, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          if (response.status !== 200) {
            this.error = response.statusText
            console.log('Error is ' + this.error)
            return
          }
          if (response.data.error !== false) {
            this.error = response.data.message
            console.log('Error is ' + this.error)
            return
          }
          this.message = response.data.message
          this.getDataFromApi()
        })
        .catch(error => {
          console.log('error', error.response)
          var data = error.response.data
          console.log(data.message)
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.message
          }
        })
    },
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getFiles()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    getFiles() {
      var url = config.serverURI + '/bulk_upload/unapproved'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token
        }
      })
          .then(response => {
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.files = response.data
            this.totalFiles = this.files.total
          })
          .catch(error => {
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.files
    },
    viewFile(item) {
      var url = config.serverURI + '/bulk_upload/' + item.id
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token
        }
      })
          .then(response => {
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.records = response.data
            this.viewRecordsDialog = true
          })
          .catch(error => {
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ApproveBulkUpload.vue?4b7ac225